import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { useState } from "react";
import { FaArrowRight, FaFileContract } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BseDto, ReceivedBseBidDto } from "../../../../autogen/bff-api";
import { urls } from "../../../../urls";
import { CreateContractModal } from "./CreateContractModal";

export const CreateContractDetail = ({ bid, sourcingEvent }: { bid: ReceivedBseBidDto; sourcingEvent: BseDto }) => {
  const navigate = useNavigate();
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <Flex key={bid.id} alignItems={"center"} py="4">
      <Text fontWeight={"semibold"} pr="4">
        {bid.owningOrganization.name}
      </Text>
      {bid.contractId ? (
        <Button
          colorScheme="teal"
          variant={"ghost"}
          rightIcon={<Icon as={FaArrowRight} />}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          onClick={() => navigate(urls.contracts.edit.go(bid.contractId!, sourcingEvent.id).review)}
        >
          {t("Go to contract")}
        </Button>
      ) : (
        <>
          <Button
            size="sm"
            variant={"outline"}
            colorScheme="teal"
            leftIcon={<Icon as={FaFileContract} />}
            onClick={() => setShowCreateModal(true)}
          >
            {t("Create contract")}
          </Button>
          {showCreateModal && (
            <CreateContractModal onClose={() => setShowCreateModal(false)} sourcingEvent={sourcingEvent} bid={bid} />
          )}
        </>
      )}
    </Flex>
  );
};
